import React from 'react';
import { Table, Skeleton } from 'antd';
import '../ipPackages/list/IPPackagesList.less';
const LoadTable = ({ columns }: any): any => {
  const blankArr = Array(8).fill(0);
  return (
    <div>
      <Table className="load-table"
        columns={columns}
        dataSource={[]}
        locale={{
          emptyText: (
            <div className="tableskeleton">
              {blankArr === null ? '' :
                blankArr.map((...params: any[]): any =>
                  <Skeleton
                    key={params[1]}
                    active={true}
                    paragraph={{ rows: 0 }}
                  />,
                )}
            </div>
          ),
        }}
      />
    </div>
  );
};
export default LoadTable;
